var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"event-control-btn",attrs:{"id":_setup.props.id,"disabled":_setup.props.isDisabled},on:{"click":function($event){return _setup.emit('click', $event)}}},[_vm._t("event-control-svg")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }